export default __webpack_public_path__ + "static/media/ic-create-transaction.4483457c.svg";